import {
  ICreateSavedSearchParams,
  ISavedSearch,
  ISavedSearchPreview,
  ISavedSearchSearchParams,
  ISavedSearchSearchResponse,
  IUpdateSavedSearchParams,
} from '@pharmsnap/shared/types/savedSearch'
import { IHistoryResult, IQuickHistoryResult } from './historyApi'
import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class SavedSearchApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async create(params: ICreateSavedSearchParams): Promise<IHttpWrap<ISavedSearch>> {
    return this.http({
      method: 'POST',
      url: this.getUrl('pharmsnap_webapi/1.0/saved-search'),
      data: params,
    })
  }

  async preview(params: { query_id: string }): Promise<IHttpWrap<ISavedSearchPreview>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('pharmsnap_webapi/1.0/saved-search/preview'),
      params,
    })
  }

  async search(params: ISavedSearchSearchParams): Promise<IHttpWrap<ISavedSearchSearchResponse>> {
    return this.http({
      method: 'POST',
      url: this.getUrl('pharmsnap_webapi/1.0/saved-search/search'),
      data: params,
    })
  }

  async update(id: string, params: IUpdateSavedSearchParams): Promise<IHttpWrap<ISavedSearch>> {
    return this.http({
      method: 'PUT',
      url: this.getUrl(`pharmsnap_webapi/1.0/saved-search/${id}`),
      data: params,
    })
  }

  async delete(id: string): Promise<IHttpWrap<void>> {
    return this.http({
      method: 'DELETE',
      url: this.getUrl(`pharmsnap_webapi/1.0/saved-search/${id}`),
    })
  }

  async run(id: string): Promise<IHttpWrap<IHistoryResult | IQuickHistoryResult>> {
    return this.http({
      method: 'POST',
      url: this.getUrl(`pharmsnap_webapi/1.0/saved-search/${id}/run`),
    })
  }
}
